export { default } from '@material-ui/lab/SpeedDialAction';
